module.exports = __webpack_public_path__ + "static/media/vip1.49f7b6d1.png";